"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var Input_1 = tslib_1.__importDefault(require("./Input"));
var theme_1 = require("../../utils/theme");
var locale_1 = require("../../common/locale");
var searchUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCI+PHBhdGggZmlsbD0iI2NiY2RkMSIgZD0iTTIzIDljNy4xOCAwIDEzIDUuODIgMTMgMTMgMCAyLjg2OC0uOTI5IDUuNTE5LTIuNTAyIDcuNjY5bDUuMDU4IDUuMDU5YTEgMSAwIDAgMSAwIDEuNDE0bC0xLjQxNCAxLjQxNGExIDEgMCAwIDEtMS40MTQgMGwtNS4wNi01LjA1OEMyOC41MTkgMzQuMDcxIDI1Ljg2OSAzNSAyMyAzNWMtNy4xOCAwLTEzLTUuODItMTMtMTNTMTUuODIgOSAyMyA5em0wIDRjLTQuOTcgMC05IDQuMDMtOSA5czQuMDMgOSA5IDkgOS00LjAzIDktOS00LjAzLTktOS05eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
var Search = (function (_super) {
    tslib_1.__extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, className = _a.className, rest = tslib_1.__rest(_a, ["className"]);
            return (h(Input_1.default, tslib_1.__assign({}, rest, { className: classNames(className, 'dui-m-input-search'), showClear: true, leftIcon: searchUrl })));
        };
        return _this;
    }
    Search.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Search;
}(React.Component));
exports.default = Search;
Search.defaultProps = {
    placeholder: locale_1.i18n('search'),
};
